{
  "dashboard": {
    "welcome": "您好，{{name}}",
    "welcomeSubtitle": "這是你目前的競賽與工作狀態。"
  },
  "judgeInvitations": {
    "title": "待回覆的評審邀請",
    "description": "主辦方邀請您擔任評審。接受後即可在評審任務頁看到指派給您的作品；若無法擔任，可以婉拒。",
    "expires": "回覆期限 {{date}}",
    "accept": "接受邀請",
    "decline": "婉拒",
    "reasonLabel": "婉拒原因（選填）",
    "confirmDecline": "確認婉拒",
    "cancel": "取消",
    "accepted": "已接受邀請，您現在是這場競賽的評審。",
    "goToJudging": "前往評審任務",
    "declined": "已婉拒邀請，主辦方可以在後台看到。",
    "error": "操作失敗，邀請可能已失效，請重新整理後再試。"
  },
  "nextActions": {
    "title": "我的下一步",
    "priority": {
      "p0": "已逾期",
      "p1": "即將截止",
      "p2": "待處理"
    },
    "item": {
      "adminPublish": "完成競賽設定並發布",
      "judgePending": "{{count}} 個評審任務待處理",
      "platformGovernance": "{{count}} 個競賽申請等待審核",
      "studentRegistration": "完成報名資料",
      "studentRegistrationUpdate": "補填報名資料（表單有必填項目尚未完成）",
      "studentTeam": "建立或加入團隊",
      "studentSubmission": "完成作品繳交"
    },
    "cta": {
      "adminPublish": "管理競賽 →",
      "judgePending": "前往評審 →",
      "platformGovernance": "前往處理 →",
      "studentRegistration": "繼續報名 →",
      "studentRegistrationUpdate": "補填報名資料 →",
      "studentTeam": "管理團隊 →",
      "studentSubmission": "繼續編輯作品 →"
    },
    "deadline": "截止：{{date}}",
    "empty": {
      "title": "目前沒有需要立即處理的事項",
      "description": "你可以探索新的競賽，或查看目前參與的競賽。",
      "exploreCta": "探索競賽"
    }
  },
  "workspaces": {
    "title": "我的工作區",
    "participate": {
      "title": "參賽",
      "count": "{{count}} 場進行中",
      "cta": "繼續參賽 →"
    },
    "manage": {
      "title": "競賽管理",
      "count": "{{count}} 場管理中",
      "cta": "管理競賽 →"
    },
    "judge": {
      "title": "評審",
      "count": "{{count}} 個評審任務",
      "cta": "進入評審 →"
    },
    "platform": {
      "title": "平台治理",
      "count": "{{count}} 件需要處理",
      "cta": "管理平台 →"
    }
  },
  "recent": {
    "title": "最近使用的競賽",
    "empty": "您尚未參與任何競賽。",
    "nextDeadline": "下一個期限"
  },
  "discoveryPreview": {
    "title": "探索競賽",
    "exploreAll": "探索所有競賽 →",
    "viewDetails": "查看競賽 →"
  },
  "hero": {
    "liveBadge": "{{count}} 個競賽公開中",
    "title": "讓競賽更專業，讓創意被看見",
    "subtitle": "NAPAICP 從報名到決選，一套系統完成公平、可追溯的競賽管理",
    "description": "NAPAICP 競賽平台提供從團隊管理、作品繳交、評審到結果發布的一站式競賽管理體驗，讓每一次競賽都更透明、更有公信力。",
    "primaryCta": "立即登入",
    "secondaryCta": "了解如何開始"
  },
  "publishedCompetitions": {
    "heading": "目前公開中的競賽",
    "description": "不需要登入，即可即時查看平台上目前公開的所有競賽。",
    "empty": "目前沒有公開中的競賽，之後開放會顯示在這裡。",
    "nextDate": "最近時程：{{date}}",
    "viewDetails": "查看競賽 →",
    "filters": {
      "searchPlaceholder": "搜尋競賽名稱或摘要",
      "statusLabel": "狀態",
      "statusAny": "所有狀態",
      "participationLabel": "參賽方式",
      "participationAny": "個人／團隊皆可",
      "categoryLabel": "分類",
      "categoryAny": "所有分類",
      "individual": "個人",
      "team": "團隊",
      "sortLabel": "排序",
      "sortNewest": "最新",
      "sortDeadline": "依截止時間",
      "closingSoon": "即將截止（7 天內）",
      "noMatches": "沒有符合篩選條件的競賽，請試著調整搜尋或篩選條件。",
      "previousPage": "上一頁",
      "nextPage": "下一頁",
      "pageOf": "第 {{page}} 頁，共 {{totalPages}} 頁"
    }
  },
  "roles": {
    "heading": "選擇您的角色，開始使用平台",
    "student": {
      "title": "學生",
      "description": "加入團隊、填寫競賽表單、提交作品、查看提交狀態與結果。",
      "cta": "前往學生區域"
    },
    "judge": {
      "title": "評審",
      "description": "查看評審指派、依 Rubric 評分、提交評分。",
      "cta": "前往評審區域"
    },
    "admin": {
      "title": "管理者",
      "description": "建立與管理競賽、管理團隊與作品、設定 Rubric、指派評審、管理結果。",
      "cta": "前往管理區域"
    }
  },
  "features": {
    "heading": "平台特色",
    "multiCompetition": {
      "title": "多競賽隔離",
      "description": "每場競賽獨立管理團隊、作品與權限，互不干擾。"
    },
    "dynamicForms": {
      "title": "動態報名與作品表單",
      "description": "依競賽需求自訂報名與繳交表單欄位，隨版本發布更新。"
    },
    "fileVersioning": {
      "title": "私有檔案上傳與版本管理",
      "description": "作品檔案私密上傳並保留版本紀錄，方便追溯繳交歷程。"
    },
    "rubricJudging": {
      "title": "Rubric 評審流程",
      "description": "評審依標準化 Rubric 評分，指派透明、流程一致。"
    },
    "lifecycle": {
      "title": "競賽生命週期管理",
      "description": "從報名、繳交、評審到結果發布，各階段狀態清楚可控。"
    },
    "resultsAudit": {
      "title": "結果與 Audit Trail",
      "description": "結果計算、鎖定與發布皆留有紀錄，變更歷程可查核。"
    }
  },
  "coreMoat": {
    "heading": "為什麼值得信任",
    "description": "NAPAICP 競賽平台實際具備的行為，每一項都可以被驗證。",
    "items": {
      "integrity": {
        "title": "完整性",
        "description": "正式提交後保留原始版本與提交時間，不會被覆蓋或悄悄消失。"
      },
      "fairness": {
        "title": "公平",
        "description": "評審端 API 不回傳不應揭露的參賽者身分資訊，並要求申報利益衝突後迴避評分。"
      },
      "governance": {
        "title": "治理",
        "description": "所有授權判斷在伺服器端執行、依競賽與角色分別控制；介面上的顯示或隱藏不是安全邊界。"
      },
      "auditability": {
        "title": "可稽核",
        "description": "成績、權限與重要狀態的異動保留操作者、時間與原因，形成可查核的紀錄。"
      },
      "isolation": {
        "title": "隔離",
        "description": "不同競賽的作品、團隊與權限彼此隔離，一場競賽的資料不會外流到另一場。"
      }
    }
  },
  "learnMore": {
    "heading": "想了解更多？"
  },
  "trust": {
    "heading": "平台開發團隊",
    "intro": "NAPAICP 競賽平台 由 NAPAI 計畫 與 NTPU AI4X 研究中心共同合作開發",
    "sponsorHeading": "指導單位",
    "partnersHeading": "合作單位",
    "teamHeading": "NAPAI 計畫團隊",
    "visitProgram": "NAPAI 計畫",
    "visitCenter": "NTPU AI4X 研究中心",
    "visitPerson": "前往 {{name}} 的個人網頁",
    "roles": {
      "pi": "計畫主持人",
      "coPi": "協同主持人"
    },
    "members": {
      "chchang": {
        "name": "張嘉惠 教授",
        "affiliation": "國立中央大學資訊工程學系"
      },
      "myday": {
        "name": "戴敏育 教授",
        "affiliation": "國立臺北大學資訊管理研究所"
      },
      "mchu": {
        "name": "胡敏君 教授",
        "affiliation": "國立清華大學資訊工程學系"
      }
    }
  }
}
